export default function accordionTeamScript() {

  const accordions = document.querySelectorAll('.c-accordion-team__accordion');

  const openAccordion = (item) => {
    const content = item.querySelector('.c-accordion-team__expand-content');
    item.classList.add('c-accordion-team__expand--active');
    content.style.maxHeight = content.scrollHeight + 'px';
  };

  const closeAccordion = (item) => {
    const content = item.querySelector('.c-accordion-team__expand-content');
    item.classList.remove('c-accordion-team__expand--active');
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
  
    const items = accordion.querySelectorAll('.c-accordion-team__expand');

    if (!items) {
      return;
    }

    items.forEach((item) => {
      const header = item.querySelector('.c-accordion-team__expand-button');
      const content = item.querySelector('.c-accordion-team__expand-content');

      header.onclick = () => {
        if (content.style.maxHeight) {
          header.querySelector('span').innerHTML = header.dataset.toggleText;
          closeAccordion(item);
        } else {
          items.forEach((item) => closeAccordion(item));
          header.querySelector('span').innerHTML = header.dataset.toggleActiveText;
          openAccordion(item);
        }
      };
    });
  });
}
